'use client'

import BlogItem from '@/entities/BlogItem'
import { useState, useMemo } from 'react'
import { useCutLengthText } from '@/shared/hooks/useCutLengthText.js'
import { Search } from '@/features/blog-page/Search/ui/Search/Search.jsx'

export const BlogPage = ({ blogList }) => {
    const [filteredValue, setFilteredValue] = useState('')
    const [countShowPosts, setCountShowPosts] = useState(6)

    // Фильтрация и обработка данных
    const filteredBlogs = useMemo(() => {
        return blogList.filter(({ title }) =>
            title.toLowerCase().includes(filteredValue.toLowerCase())
        ).reverse()
    }, [blogList, filteredValue])

    const visibleBlogs = useMemo(() => {
        return filteredBlogs.slice(0, countShowPosts)
    }, [filteredBlogs, countShowPosts])

    const showLoadMore = useMemo(() => {
        return countShowPosts < filteredBlogs.length && !filteredValue
    }, [countShowPosts, filteredBlogs, filteredValue])

    // Обработка позиционирования элементов
    const getPositionClass = (index) => {
        const position = (index % 4) + 1
        return position === 1 || position === 4 ? 'item-long' : 'item-short'
    }

    return (
        <div className={'BlogPage'}>
            {/* <Helmet>
                <title>Блог - Academie.club</title>
                <meta
                    name="keywords"
                    content="Блог, Академия клаб , Академия клаб, интернет-магазин"
                />
                <meta
                    name="description"
                    content="Блог - Интернет-магазин Академия клаб Академия клаб"
                />
            </Helmet> */}

            <div className={'header'}>
                <h1>Блог</h1>
                <Search
                    value={filteredValue}
                    setFilteredValue={setFilteredValue}
                />
            </div>

            <div className={'blog-items'}>
                {visibleBlogs.map(
                    ({ image, title, description, blog_id, url }, index) => {
                        const cutText = useCutLengthText(
                            String(description),
                            50
                        )

                        return url ? (
                            <BlogItem
                                key={blog_id} // Используем ID вместо image
                                text={cutText}
                                title={title}
                                image={image}
                                itemId={blog_id}
                                itemUrl={url}
                                itemClass={getPositionClass(index)}
                            />
                        ) : null
                    }
                )}
            </div>

            {showLoadMore && (
                <div className={'action'} onClick={() => setCountShowPosts((prev) => { return prev + 5 })}>
                    <button>
                        <img src="/icons/showMore.svg" alt="Загрузить ещё" />
                        <span>Показать ещё</span>
                    </button>
                </div>
            )}
        </div>
    )
}
